import { render, staticRenderFns } from "./sjblMid.vue?vue&type=template&id=8b38f4b6&scoped=true&"
import script from "./sjblMid.vue?vue&type=script&lang=js&"
export * from "./sjblMid.vue?vue&type=script&lang=js&"
import style0 from "./sjblMid.vue?vue&type=style&index=0&id=8b38f4b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b38f4b6",
  null
  
)

export default component.exports